import { Link, useNavigate } from "react-router-dom";
import "./spListPendingDocument.scss";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Button, Col, Form, Input, Row, Table } from "antd";
import { NotFound } from "../../../../sources/svg/svg";
import { Content } from "antd/es/layout/layout";
import { _adr } from "../../../../address";
import { HomeOutlined, LeftOutlined } from "@ant-design/icons";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import { complexDigitToman, convertToJalaliWithTime } from "../../../../tools/tools";
import "../../shop/sp.scss";
const SPListPendingDocument = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const { querySPPurchaseDealerByState } = useDealer();

	const [purchaseList, setPurchaseList] = useState([]);
	const [resultSearch, setResultSearch] = useState([]);

	//state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	const [bTable, setBTable] = useState([]);
	const [tTable, setTTable] = useState([]);

	useEffect(() => {
		PurchaseListServ();
	}, [currentPage]);

	const PurchaseListServ = async () => {
		let payload = {
			purchasestate: [1, 8, 15],
			search: {
				sort: "",
				filter: "",
				entriesperpage: 10,
				page: currentPage === 0 ? 0 : currentPage - 1,
				totalrowcount: 0,
			},
		};
		let response = await querySPPurchaseDealerByState(payload);
		if (response) {
			setPurchaseList(response?.Result);
			setResultSearch(response?.Result);
			setTotalRecord(response?.searchconfigmodel?.totalrowcount);
		}
	};

	const handleSearch = (e) => {
		let search = e.target.value;
		let result = purchaseList.filter((item) => {
			return Object.keys(item).some((k) => {
				return String(item[k]).toLowerCase().includes(search.toLowerCase());
			});
		});
		setResultSearch(result);
	};

	return (
		<>
			<div className="container-main container-sp">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.pending.list.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.pending.list.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="holder-form-filter">
									<Form layout="vertical">
										<Row gutter={16}>
											<Col span={6}>
												<Form.Item className="input-normal" label="جستجو">
													<Input placeholder="جستجو" dir="ltr" allowClear onChange={handleSearch} />
												</Form.Item>
											</Col>
										</Row>
									</Form>
								</div>
								<div className="holder-table">
									<Table
										className="tbl-normal"
										columns={[
											{
												title: "کدپیگیری",
												dataIndex: "trackcode",
												key: "trackcode",
												width: 150,
											},
											{
												title: "شماره",
												dataIndex: "msisdn",
												key: "msisdn",
												width: 150,
											},
											{
												title: "نوع",
												dataIndex: "type",
												key: "type",
												width: 150,
											},
											{
												title: "قیمت (تومان)",
												dataIndex: "price",
												key: "price",
												width: 150,
											},
											{
												title: "سود شما از فروش (تومان)",
												dataIndex: "commission",
												key: "commission",
												width: 150,
											},
											{
												title: "تاریخ خرید",
												dataIndex: "purchaseDate",
												key: "purchaseDate",
												width: 150,
											},
											{
												title: "وضعیت",
												dataIndex: "status",
												key: "status",
												width: 150,
											},
											{
												title: "",
												dataIndex: "action",
												key: "action",
												width: 150,
											},
										]}
										scroll={{ y: "100%" }}
										locale={{
											emptyText: (
												<>
													<NotFound text={"رکوردی یافت نشد."} />
												</>
											),
										}}
										pagination={{
											className: "page-pagination",
											// position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
											onChange: (page) => {
												setCurrentPage(page);
											},
											pageSize: 10,
											align: "start",
											current: currentPage === 0 ? 1 : currentPage,
											total: totalRecord,
											showSizeChanger: false,
										}}
										dataSource={resultSearch.map((item, key) => ({
											key: key,
											trackcode: item.stR_PurchaseFollowupCode,
											msisdn: item.inT_MSISDN,
											type: item.stR_BundleName,
											price: complexDigitToman(item.inT_PurchaseAmount),
											commission: complexDigitToman(item.inT_PackageSalesCommission),
											purchaseDate: convertToJalaliWithTime(item.dtE_PurchaseDate),
											status: <span className="color-orange">نقص مدرک</span>,
											action: (
												<>
													<Link
														className="arrow-naghs"
														to={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.upload}
														state={item}>
														<LeftOutlined />
													</Link>
												</>
											),
										}))}></Table>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default SPListPendingDocument;
